// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"453":"03dbd34f","667":"90b4f535","977":"ed955cf5"}[chunkId] + ".chunk.js");